export const download = (data, fileName) => {
    var fileURL = window.URL.createObjectURL(new Blob([data]));
    var fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', fileName);
    document.body.appendChild(fileLink);

    fileLink.click();
}

const fieldsWithNewFilesNumber = (array) => {
    let fieldFilesNumber = 0

    array.forEach(field => {
        let hasFiles = false

        field.value.files.forEach(file => {
            if (file.id === 0) {
                hasFiles = true
            }
        })

        if (hasFiles) {
            ++fieldFilesNumber
        }
    })

    return fieldFilesNumber
}

// AI generated function
export const createCSV = (array, columnLabels = null) => {
    if (!Array.isArray(array) || array.length === 0) {
        return '';
    }

    // gather all keys present in data (preserve discovery order)
    const dataCols = array.reduce((acc, obj) => {
        if (obj && typeof obj === 'object') {
            Object.keys(obj).forEach(k => {
                if (!acc.includes(k)) acc.push(k);
            });
        }
        return acc;
    }, []);

    // Build columns and label map based on optional columnLabels (object map only)
    let cols = [];
    const labelMap = {};

    if (columnLabels && typeof columnLabels === 'object') {
        // object map { field: 'Label' } - preserve object's key order
        cols = Object.keys(columnLabels);
        Object.keys(columnLabels).forEach(k => labelMap[k] = columnLabels[k]);

        // append any remaining columns that were found in data but not specified in columnLabels
        dataCols.forEach(c => {
            if (!cols.includes(c)) cols.push(c);
        });
    } else {
        cols = dataCols;
    }

    const escapeCell = (value) => {
        if (value === null || value === undefined) return '';
        // If object or array, stringify
        let str = typeof value === 'object' ? JSON.stringify(value) : String(value);
        // escape double quotes and wrap in quotes if needed
        if (/[",\r\n]/.test(str)) {
            str = '"' + str.replace(/"/g, '""') + '"';
        }

        return str;
    }

    const header = cols.map(c => escapeCell(labelMap[c] ?? c)).join(',');
    const rows = array.map(row => cols.map(col => escapeCell(row ? row[col] : '')).join(',')).join('\r\n');

    return header + (rows ? '\r\n' + rows : '');
}

export default {
    download,
    fieldsWithNewFilesNumber,
    createCSV,
}
